// src/components/Routes/index.js
import React, { Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import { ROUTES_CONFIG } from "./config";
import RouteMiddleware from "./RouteMiddleware";

// Global JSON-LD additions beyond what's static in public/index.html.
// Organization + WebSite identity itself lives there — see
// src/schemas/GlobalSchema.jsx for why it isn't repeated here.
import GlobalSchema from "schemas/GlobalSchema";

export const Routes = () => {
  return (
    <>
      {/* Renders once across the app */}
      <GlobalSchema />

      <Suspense fallback={<p></p>}>
        <Switch>
          {ROUTES_CONFIG.map((route, i) => (
            <RouteMiddleware
              key={i}
              exact={!!route.exact}
              path={route.path}
              route={route}
              component={() => route.component}
            />
          ))}
          <Route component={() => <div>404</div>} />
        </Switch>
      </Suspense>
    </>
  );
};